export default __webpack_public_path__ + "static/media/ISMO CLASS-2 EXAM PATTERN 2026-27.e3cb2994.pdf";